<template>
 <ActivityHistory title="Vehicle Activity History" :subtitle="subtitleText" :records="records" :loading="loading" @close="closeDialog"></ActivityHistory>
</template>

<script>
import axios from "@/axios/axios-global";
import ActivityHistory from "@/components/common/ActivityHistory.vue";
export default {
 components: { ActivityHistory },
 props: {
  token: String,
  // optional, e.g. "KA40B5685 · Maruti Tour S · Sedan"
  subtitle: { type: String, default: "" },
 },
 data: () => {
  return {
   vehicleDetails: {},
   loading: false,
  };
 },
 mounted() {
  this.getVehicleDetails();
 },
 computed: {
  subtitleText() {
   if (this.subtitle) return this.subtitle;
   const v = this.vehicleDetails || {};
   const details = v.details || {};
   const model = [details.manufacturer && details.manufacturer.name, details.model && details.model.name].filter(Boolean).join(" ");
   return [v.vehicleno, model].filter(Boolean).join(" · ");
  },
  records() {
   const reasons = (this.vehicleDetails && this.vehicleDetails.reason) || [];
   return reasons.map((remark) => ({
    employee: remark.remarksBy && typeof remark.remarksBy === "object" ? remark.remarksBy.name : remark.remarksBy,
    reason: remark.reason,
    date: remark.date,
    action: remark.action,
   }));
  },
 },
 methods: {
  async getVehicleDetails() {
   this.loading = true;
   try {
    const response = await axios.post("vehicle/details", { vehicleId: this.token });
    this.vehicleDetails = response.data || {};
   } catch (error) {
    console.error(error);
   } finally {
    this.loading = false;
   }
  },
  closeDialog() {
   this.$emit("edit-dialog");
  },
 },
};
</script>
